import React, { useEffect, useState } from 'react';

const BasicTextComponentPreview = (props) => {
  const { config } = props;
  const [currentData, setCurrentData] = useState({});

  useEffect(() => {
    const { text, textType, textStyle, textPadding } = config;

    const tempData = {
      text,
      textType,
      isBold: textStyle?.isBold,
      isItalic: textStyle?.isItalic,
      isUnderlined: textStyle?.isUnderlined,
      alignment: textStyle?.alignment.toLowerCase(),
      color: textStyle?.color,
      paddingTop: textPadding?.paddingTop,
      paddingBottom: textPadding?.paddingBottom,
    };
    setCurrentData(tempData);
  }, [config, config.text]);

  const generateClass = (type) => {
    if (type === 'HEADLINE') {
      return {
        fontSize: 2 + 'em',
        fontWeight: currentData.isBold ? 'bold' : 'normal',
        fontStyle: currentData.isItalic ? 'italic' : 'normal',
        textDecoration: currentData.isUnderlined ? 'underline' : 'none',
        textAlign: !currentData.alignment ? 'center' : currentData.alignment,
        paddingTop: currentData.paddingTop,
        paddingBottom: currentData.paddingBottom,
        color: currentData.color,
        paddingLeft: 3,
        paddingRight: 3,
      };
    } else if (type === 'SUBTEXT') {
      return {
        fontSize: 1.5 + 'em',
        fontWeight: currentData.isBold ? 'bold' : 'normal',
        fontStyle: currentData.isItalic ? 'italic' : 'normal',
        textDecoration: currentData.isUnderlined ? 'underline' : 'none',
        textAlign: !currentData.alignment ? 'center' : currentData.alignment,
        paddingTop: currentData.paddingTop,
        paddingBottom: currentData.paddingBottom,
        color: currentData.color,
        paddingLeft: 3,
        paddingRight: 3,
      };
    } else if (type === 'BODY') {
      return {
        fontSize: 1.17 + 'em',
        fontWeight: currentData.isBold ? 'bold' : 'normal',
        fontStyle: currentData.isItalic ? 'italic' : 'normal',
        textDecoration: currentData.isUnderlined ? 'underline' : 'none',
        textAlign: !currentData.alignment ? 'center' : currentData.alignment,
        paddingTop: currentData.paddingTop,
        paddingBottom: currentData.paddingBottom,
        color: currentData.color,
        paddingLeft: 3,
        paddingRight: 3,
      };
    }
  };
  return (
    <div>
      <div style={currentData?.textType !== '' ? generateClass(currentData?.textType) : {}}>
        {currentData?.text}
      </div>
    </div>
  );
};

export default BasicTextComponentPreview;
